// 販売対象の3コンテンツ（Issue #36）。
//
// 識別子はサーバ（modules/billing/pricing.py の BILLING_CONTENTS）と同じ。
// **日本語ラベルと遷移先はフロントの責務**なのでここに置き、ナビ・プラン選択・マイページ・
// ロック表示で共用する。金額は持たない（サーバの価格表が正 / §1.1）。
export const CONTENT_KEYS = ['jra', 'nar', 'keirin'];

export const CONTENTS = {
  jra: { label: '中央競馬', caption: 'JRA', path: '/chiriri_model_race_list' },
  nar: { label: '地方競馬', caption: 'NAR', path: '/nar_model_race_list' },
  keirin: { label: '競輪', caption: 'KEIRIN', path: '/keirin_model_race_list' },
};

export const contentLabel = (key) => CONTENTS[key]?.label || key;
